import React, { FunctionComponent, lazy, Suspense } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const DesignIconsMap = {
  Academy: lazy(() => import('./icons/Academy.icon.svg?react')),
  Affiliate: lazy(() => import('./icons/Affiliate.icon.svg?react')),
  Alarm: lazy(() => import('./icons/Alarm.icon.svg?react')),
  ArrowDown: lazy(() => import('./icons/ArrowDown.icon.svg?react')),
  ArrowUp: lazy(() => import('./icons/ArrowUp.icon.svg?react')),
  BalanceCoins: lazy(() => import('./icons/BalanceCoins.icon.svg?react')),
  BalanceTTPLogo: lazy(() => import('./icons/BalanceTTPLogo.icon.svg?react')),
  Balance5ersLogo: lazy(() => import('./icons/Balance5ersLogo.icon.svg?react')),
  CartBox: lazy(() => import('./icons/CartBox.icon.svg?react')),
  CaretLeft: lazy(() => import('./icons/CaretLeft.icon.svg?react')),
  CaretRight: lazy(() => import('./icons/CaretRight.icon.svg?react')),
  Community: lazy(() => import('./icons/Community.icon.svg?react')),
  HandCoins: lazy(() => import('./icons/HandCoins.icon.svg?react')),
  Hat: lazy(() => import('./icons/Hat.icon.svg?react')),
  HandOk: lazy(() => import('./icons/HandOk.icon.svg?react')),
  HandOkTtpDark: lazy(() => import('./icons/HandOkTtpDark.icon.svg?react')),
  HandOkTtpLight: lazy(() => import('./icons/HandOkTtpLight.icon.svg?react')),
  HandOkDark: lazy(() => import('./icons/HandOk-dark.icon.svg?react')),
  HeaderRocket: lazy(() => import('./icons/HeaderRocket.icon.svg?react')),
  Calendar: lazy(() => import('./icons/Calendar.icon.svg?react')),
  Card: lazy(() => import('./icons/Card.icon.svg?react')),
  ThumbsDown: lazy(() => import('./icons/ThumbsDown.icon.svg?react')),
  CaretDown: lazy(() => import('./icons/CaretDown.icon.svg?react')),
  CaretUp: lazy(() => import('./icons/CaretUp.icon.svg?react')),
  Diamond: lazy(() => import('./icons/Diamond.icon.svg?react')),
  Five: lazy(() => import('./icons/five.icon.svg?react')),
  FeedbackStar: lazy(() => import('./icons/FeedbackStar.svg?react')),
  FeedbackStarLight: lazy(() => import('./icons/FeedbackStarLight.svg?react')),
  FeedbackStarTtpDark: lazy(
    () => import('./icons/FeedbackStarTtpDark.icon.svg?react'),
  ),
  FeedbackStarTtpLight: lazy(
    () => import('./icons/FeedbackStarTtpLight.icon.svg?react'),
  ),
  FreeTag: lazy(() => import('./icons/FreeTag.icon.svg?react')),
  Email: lazy(() => import('./icons/Email.icon.svg?react')),
  EmptyCart: lazy(() => import('./icons/Empty.icon.svg?react')),
  EmptyState: lazy(() => import('./icons/EmptyState.icon.svg?react')),
  Globe: lazy(() => import('./icons/Globe.icon.svg?react')),
  Graph: lazy(() => import('./icons/Graph.icon.svg?react')),
  AllSet: lazy(() => import('./icons/Allset.icon.svg?react')),
  AllSetDark: lazy(() => import('./icons/Allset-dark.icon.svg?react')),
  ICalendarBlank: lazy(() => import('./icons/ICalendarBlank.icon.svg?react')),
  ShoppingBag: lazy(() => import('./icons/ShoppingBag.icon.svg?react')),
  UsersThree: lazy(() => import('./icons/UsersThree.icon.svg?react')),
  WarningCircle: lazy(() => import('./icons/WarningCircle.icon.svg?react')),
  Info: lazy(() => import('./icons/Info.icon.svg?react')),
  MetaTraderFive: lazy(() => import('./icons/MetaTraderFive.icon.svg?react')),
  CTrader: lazy(() => import('./icons/CTrader.icon.svg?react')),
  TraderEvolution: lazy(() => import('./icons/TraderEvolution.icon.svg?react')),
  P: lazy(() => import('./icons/P.icon.svg?react')),
  Day: lazy(() => import('./icons/Day.icon.svg?react')),
  Swing: lazy(() => import('./icons/Swing.icon.svg?react')),
  SadSmiley: lazy(() => import('./icons/SadSmiley.icon.svg?react')),
  HourGlass: lazy(() => import('./icons/HourGlass.icon.svg?react')),
  MagnifyingGlass: lazy(() => import('./icons/MagnifyingGlass.icon.svg?react')),
  MegaPhone: lazy(() => import('./icons/Megaphone.icon.svg?react')),
  Megaphone: lazy(() => import('./icons/Megaphone.icon.svg?react')),
  XCircle: lazy(() => import('./icons/XCircle.icon.svg?react')),
  Funnel: lazy(() => import('./icons/Funnel.icon.svg?react')),
  Options: lazy(() => import('./icons/Options.icon.svg?react')),
  RedFlag: lazy(() => import('./icons/RedFlag.icon.svg?react')),
  RiskNote: lazy(() => import('./icons/RiskNote.icon.svg?react')),
  Rocket: lazy(() => import('./icons/Rocket.icon.svg?react')),
  ShootingStars: lazy(() => import('./icons/ShootingStars.icon.svg?react')),
  Edit: lazy(() => import('./icons/Edit.icon.svg?react')),
  Trash: lazy(() => import('./icons/Trash.icon.svg?react')),
  Flag: lazy(() => import('./icons/Flag.icon.svg?react')),
  Plus: lazy(() => import('./icons/Plus.icon.svg?react')),
  EmptyStateCFO: lazy(() => import('./icons/EmptyStateCFO.icon.svg?react')),
  Plant: lazy(() => import('./icons/Plant.icon.svg?react')),
  Pencil: lazy(() => import('./icons/Pencil.icon.svg?react')),
  HandsClap: lazy(() => import('./icons/HandsClap.icon.svg?react')),
  Heart: lazy(() => import('./icons/Heart.icon.svg?react')),
  ChatCircle: lazy(() => import('./icons/ChatCircle.icon.svg?react')),
  DollarNote: lazy(() => import('./icons/DollarNote.icon.svg?react')),
  YoutubeMobileDisabled: lazy(
    () => import('./icons/YoutubeMobileDisabled.icon.svg?react'),
  ),
  YoutubeMobileEnabled: lazy(
    () => import('./icons/YoutubeMobileEnabled.icon.svg?react'),
  ),
  YoutubeLiveLogoDisabled: lazy(
    () => import('./icons/YoutubeLiveLogoDisabled.icon.svg?react'),
  ),
  YoutubeLiveLogoEnabled: lazy(
    () => import('./icons/YoutubeLiveLogoEnabled.icon.svg?react'),
  ),
  DiscordDisabled: lazy(() => import('./icons/DiscordDisabled.icon.svg?react')),
  DiscordEnabled: lazy(() => import('./icons/DiscordEnabled.icon.svg?react')),
  VerifiedLight: lazy(() => import('./icons/Verified.icon.light.svg?react')),
  VerifiedDark: lazy(() => import('./icons/Verified.icon.dark.svg?react')),
  ProfitableLight: lazy(
    () => import('./icons/Profitable.icon.light.svg?react'),
  ),
  ProfitableDark: lazy(() => import('./icons/Profitable.icon.dark.svg?react')),
  Funded: lazy(() => import('./icons/Funded.icon.svg?react')),
  Popcorn: lazy(() => import('./icons/Popcorn.icon.svg?react')),
  Key: lazy(() => import('./icons/Key.icon.svg?react')),
  OpenBook: lazy(() => import('./icons/OpenBook.icon.svg?react')),
  Pinwheel: lazy(() => import('./icons/Pinwheel.icon.svg?react')),
  Users: lazy(() => import('./icons/Users.icon.svg?react')),
  Cup: lazy(() => import('./icons/Cup.icon.svg?react')),
  RevenueBag: lazy(() => import('./icons/RevenueBag.icon.svg?react')),
  Medal: lazy(() => import('./icons/Medal.icon.svg?react')),
  The5ersLogoShort: lazy(
    () => import('./icons/The5ersLogoShort.icon.svg?react'),
  ),
  The5ersLogoLong: lazy(() => import('./icons/The5ersLogoLong.icon.svg?react')),
  TTPLogo: lazy(() => import('./icons/TTPLogo.icon.svg?react')),
  TradeTalkPicked: lazy(() => import('./icons/TradeTalkPicked.svg?react')),
  TradeTalkBlocked: lazy(() => import('./icons/TradeTalkBlocked.svg?react')),
  TradeTalkPending: lazy(() => import('./icons/TradeTalkPending.svg?react')),
  TTPLogoShort: lazy(() => import('./icons/TTPLogoShort.icon.svg?react')),
  BlockedUsers5ers: lazy(
    () => import('./icons/BlockedUsers5ers.icon.svg?react'),
  ),
  BlockedUsers5ersDark: lazy(
    () => import('./icons/BlockedUsers5ersDark.icon.svg?react'),
  ),
  BlockedUsersTtp: lazy(() => import('./icons/BlockedUsersTtp.icon.svg?react')),
  BlockedUsersTtpDark: lazy(
    () => import('./icons/BlockedUsersTtpDark.icon.svg?react'),
  ),
  EmptyStateSmilley: lazy(
    () => import('./icons/EmptyStateSmilley.icon.svg?react'),
  ),
  EmptyStateSmilleyDark: lazy(
    () => import('./icons/EmptyStateSmilleyDark.icon.svg?react'),
  ),
  MyOrders: lazy(() => import('./icons/MyOrders.icon.svg?react')),

  MagicWand: lazy(() => import('./icons/MagicWand.icon.svg?react')),
  MouseClick: lazy(() => import('./icons/MouseClick.icon.svg?react')),
  Basecamp: lazy(() => import('./icons/Basecamp.icon.svg?react')),
  BasecampDark: lazy(() => import('./icons/BasecampDark.icon.svg?react')),
  ZeroLimits: lazy(() => import('./icons/ZeroLimits.icon.svg?react')),
  ZeroLimitsDark: lazy(() => import('./icons/ZeroLimitsDark.icon.svg?react')),
  OrbitingCircles: lazy(() => import('./icons/OrbitingCircles.icon.svg?react')),
  OrbitingCirclesDark: lazy(
    () => import('./icons/OrbitingCirclesDark.icon.svg?react'),
  ),
  MagicWandLeft: lazy(() => import('./icons/MagicWandLeft.icon.svg?react')),
  MegaphoneLeft: lazy(() => import('./icons/MegaphoneLeft.icon.svg?react')),
  UniversityHat: lazy(() => import('./icons/UniversityHat.icon.svg?react')),
  MegaPhoneDone: lazy(() => import('./icons/MegaPhoneDone.icon.svg?react')),
  Lock: lazy(() => import('./icons/Lock.icon.svg?react')),
  TTPLogoMonoColor: lazy(
    () => import('./icons/TTPLogoMonoColor.icon.svg?react'),
  ),
  CoinsContainedLight: lazy(
    () => import('./icons/CoinsContainedLight.svg?react'),
  ),
  CoinsContainedDark: lazy(
    () => import('./icons/CoinsContainedDark.svg?react'),
  ),
} as const;

export type DesignIconNames = keyof typeof DesignIconsMap;

export type DesignIconProps = {
  iconName: DesignIconNames;
} & (
  | ({
      useMuiSvgIcon?: true;
      props?: SvgIconProps;
    } & SvgIconProps)
  | ({
      useMuiSvgIcon: false;
      props?: Omit<SvgIconProps, 'color'> & { color?: string };
    } & Omit<SvgIconProps, 'color'> & { color?: string })
);

export const DesignIcon: FunctionComponent<DesignIconProps> = (
  componentProps,
) => {
  const { iconName, props, useMuiSvgIcon, ...directProps } = componentProps;
  const IconComponent = DesignIconsMap[iconName];

  if (!IconComponent) {
    console.warn(`Icon "${iconName}" not found in local icon set`);
    return null;
  }

  // Merge direct props with nested props, giving precedence to nested props
  const mergedProps = { ...directProps, ...props };

  return (
    <Suspense fallback={null}>
      {useMuiSvgIcon === false ? (
        <IconComponent {...mergedProps} />
      ) : (
        <SvgIcon {...(mergedProps as SvgIconProps)} component={IconComponent} />
      )}
    </Suspense>
  );
};
